module.exports = __webpack_public_path__ + "img/2010 radtour ehrenabteilung 017.382a5869.jpg";